import { getData, sendData, sendForBlobData } from './apiService';
import NotificationManager from 'react-notifications/lib/NotificationManager';

export async function getAll(query, value) {
  try {
    let response = await sendData(
      `custom-duty-invoice/search?total=true&${new URLSearchParams(query).toString()}`,
      value,
      'POST',
      false
    );
    return response;
  } catch (e) {
    NotificationManager.error('Opps. Something wrong');
    return false;
  }
}

export async function save(values) {
  try {
    return await sendData('custom-duty-invoice/create', values);
  } catch (e) {
    NotificationManager.error(e.response.data.message);
    return false;
  }
}

export async function deleteData(_id) {
  try {
    let response = await sendData('custom-duty-invoice/delete', { id: _id });
    return response;
  } catch (e) {
    NotificationManager.error('Opps. Something wrong');
    return false;
  }
}

export async function deleteAllData(data) {
  try {
    let response = await sendData('custom-duty-invoice', data, 'DELETE');
    return response;
  } catch (e) {
    NotificationManager.error('Opps. Something wrong');
    return false;
  }
}

export async function update(values) {
  try {
    return await sendData('custom-duty-invoice/update/' + values._id, values, 'PUT');
  } catch (e) {
    NotificationManager.error(e.response.data.error);
    return false;
  }
}

export async function fetchInvoiceNumber() {
  try {
    let response = await getData('custom-duty-invoice/request-invoice-number');
    return response;
  } catch (e) {
    NotificationManager.error('Opps. Something wrong');
    return false;
  }
}

export async function deleteImage(file, invoiceNumber, type) {
  try {
    return await sendData(
      `custom-duty-invoice-files/invoice-image-delete-custom?file_name=${file}&invoice_id=${invoiceNumber}&type=${type}`,
      {},
      'DELETE'
    );
  } catch (e) {
    NotificationManager.error(e.response.data.error);
    return false;
  }
}

export async function exportData(data) {
  return await sendForBlobData('custom-duty-invoice/export-custom-duty-invoice', data, {
    responseType: 'blob',
  });
}

export async function exportDataItems(data) {
  return await sendForBlobData('custom-duty-invoice/export-custom-duty-invoice-items', data, {
    responseType: 'blob',
  });
}

export async function getCustomDutyInvoiceByNumber(query) {
  try {
    let response = await getData(`custom-duty-invoice/get-custom-duty-invoice?${new URLSearchParams(query).toString()}`);
    return response;
  } catch (e) {
    NotificationManager.error('Opps. Something wrong');
    return false;
  }
}

export async function updateCustomDutyInvoice(data) {
  try {
    let response = await sendData('custom-duty-invoice/update-custom-duty-invoice', data, 'PATCH');
    return response;
  } catch (e) {
    NotificationManager.error('Opps. Something wrong');
    return false;
  }
}

export async function cancelInvoiceNumber(data) {
  try {
    let response = await sendData('custom-duty-invoice/cancel-custom-duty-invoice-number', data, 'POST');
    return response;
  } catch (e) {
    NotificationManager.error('Opps. Something wrong');
    return false;
  }
}
